import DigiSvg from "../../../../styles/images/logo/digi.svg";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Product1JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import Product2JPG from "../../../../styles/images/5af568b4909435c6a215ad5e728e902db234b673_1736597759.jpg";
import TrcuckPng from "../../../../styles/images/png/truck.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import {Navigation, Pagination, EffectFade, Autoplay, Scrollbar, A11y} from 'swiper/modules';
import { Sheet } from 'react-modal-sheet';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import { handleChangeDataModalAddresses } from '../../../../redux/actions/partials/modals/modalAddresses';
import { useCartHandlers } from '../../../../utils/cartHandler';
import apiRequest from '../../../../utils/apiRequest';
import { CHECKOUT_SHIPPING_POST, CHECKOUT_REGISTER_ORDER_POST, IMAGE_ADDRESS } from '../../../../apis';
import { handleChangeDataPageCheckoutShipping } from '../../../../redux/actions/pages/checkout/shipping';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleChangeDataModalSuccessMsg } from '../../../../redux/actions/partials/modals/modalSuccessMsg';





const ShippingMobile = () => {
 	
 	const dispatch = useDispatch();
 	const navigate = useNavigate();

 	const { token } = useSelector(state => state.login);
	const { activeAddress } = useSelector(state => state.user);
	const { carts, totalPrice } = useSelector(state => state.shoppingCart);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { contents } = useSelector(state => state.shipping);

	const { handleAddToCartTwo, handleMinusBtnTwo } = useCartHandlers(null, null, null);


	const totalProductPrice = carts.reduce((sum, item) => {
	  	const price = item.marketPrice !== null ? item.marketPrice : item.price;
	  	return sum + (price * item.number);
	}, 0);
 	const profit = totalProductPrice - totalPrice;
 	const profitPercent = totalProductPrice > 0 ? Math.floor((totalProductPrice - totalPrice) * 100 / totalProductPrice) : 0;

	useEffect(() => {
        callApiShipping();
    }, [ShippingMobile, carts]);


    const callApiShipping = () => {
    	if(! isBackdropLoading) {
    		let postData = {};
    		carts.map(function(cart, index) {
	            postData = {
	                ...postData, 
	                [`sku[${index}]`]: cart.sku,
	                [`seller[${index}]`]: cart.seller.id,
	                [`amount[${index}]`]: cart.number,
	            }
	        });
    		apiRequest({
			    dispatch,
			    endpoint: (CHECKOUT_SHIPPING_POST),
			    data: postData,
			    method: 'post',
			    token: token,
			    onSuccess: (res) => {
			    	res.contents.map((content, index) => {
			    		content.showSheetDayTime = false;
			    	});
			    	dispatch(handleChangeDataPageCheckoutShipping('contents', res.contents));
			    },
		  	});
    	}
    };


    const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};


 	const formatTime = (timeStr) => {
  		const [hh, mm, ss] = timeStr.split(':');

  		if (mm === '00' && ss === '00') {
    		return String(parseInt(hh, 10)); // فقط ساعت
  		} else if (ss === '00') {
    		return `${hh}:${mm}`; // ساعت و دقیقه
  		} else {
    		return `${hh}:${mm}:${ss}`; // کامل، اگر خواستی ثانیه رو هم نگه داری
  		}
	};

	const handleClickDay = (contentKey, dayKey) => {
		let newContents = [...contents];
		newContents[contentKey].available_days.map((day, dayIndex) => {
			day.isSelect = dayKey === dayIndex;
		});
		dispatch(handleChangeDataPageCheckoutShipping('contents', newContents));
	};

	const handleClickTime = (contentKey, timeKey) => {
		let selectedDay = contents[contentKey].available_days.find(day => day.isSelect === true);
		let newContents = [...contents];
		newContents[contentKey].available_days.map((day, dayIndex) => {
			day.time_slots.map((time, timeIndex) => {
				time.isSelect = selectedDay.date === day.date && timeKey === timeIndex;
			});
		});
		newContents[contentKey].showSheetDayTime = false; // baraye baste shodane sheete entekhabe zaman
		dispatch(handleChangeDataPageCheckoutShipping('contents', newContents));
	};

	const calculateShippingCosts = () => {
	  	const result = {};

	  	contents.forEach((group) => {
		    const { shipping_type, available_days } = group;

		    const selectedDay = available_days.find(day => day.isSelect === true);
    		const price = selectedDay?.price ?? 0;
    		const priceTxt = selectedDay?.priceTxt ?? 0;

		    // اگر قبلاً این نوع ارسال اضافه نشده بود، اضافه کن
		    if (!result[shipping_type]) {
		      	result[shipping_type] = {price, priceTxt};
		    }
	  	});

	  	return result;
	};
	const shippingPrices = calculateShippingCosts();



	const totalShippingPrice = Object.entries(shippingPrices).reduce((sum, [type, {price}]) => {
	  	return sum + parseInt(price);
	}, 0);


	const isAllShippingTypesSelected = contents.every(group => {
	  	const selectedDay = group.available_days.find(day => day.isSelect === true);
	  	if (!selectedDay) return false;

	  	const selectedSlot = selectedDay.time_slots?.find(slot => slot.isSelect === true);
	  	return !!selectedSlot;
	});


	const firstIncomplete = contents.find(group => {
	  	const selectedDay = group.available_days.find(day => day.isSelect === true);
	  	if (!selectedDay) return true;

	  	const selectedSlot = selectedDay.time_slots?.find(slot => slot.isSelect === true);
	  	return !selectedSlot;
	});

	const sectionRefs = useRef({}); // کلیدها: shipping_type



	const buildShippingPayload = () => {
		if (!Array.isArray(contents)) {
		    console.error('مقدار contents نامعتبر است:', contents);
		    return [];
  		}

	  	return contents.map(group => {
		    const selectedDay = group.available_days.find(day => day.isSelect);
		    const selectedSlot = selectedDay?.time_slots.find(slot => slot.isSelect);

		    return {
		      	shipping_type: group.shipping_type, // "ارسال عادی", "ارسال کالاهای بزرگ و سنگین", ...
		      	shipping_type_en: group.shipping_type_en, // "ارسال عادی", "ارسال کالاهای بزرگ و سنگین", ...
		      	delivery_method: group.delivery_method, // "platform" یا "seller"
		      	selected_day: selectedDay?.date ?? null,
		      	selected_slot: selectedSlot?.id ?? null,
		      	products: group.items.map(p => ({
			        sku: p.sku,
			        qty: p.amount,
			        seller_id: p.seller,
			        name: p.product
		      	}))
		    };
	  	});
	};

	const handleClickPayBtn = () => {
		if (isAllShippingTypesSelected) {
		    if(! isBackdropLoading) {
				if(!activeAddress) {
					dispatch(handleSetOpenCustomSnackbar(true, {message: 'آدرس را انتخاب کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));
					return;
				}
	    		const payload = buildShippingPayload();

	    		apiRequest({
				    dispatch,
				    endpoint: (CHECKOUT_REGISTER_ORDER_POST),
				    data: {data: payload, address: activeAddress.id},
				    method: 'post',
				    token: token,
				    onSuccess: (res) => {
				    	dispatch(handleChangeDataModalSuccessMsg('isOpen', true));
        				setTimeout(() => dispatch(handleChangeDataModalSuccessMsg('isActive', true)), 0);
				    },
			  	});
	    	}

	  	} else if (firstIncomplete) {
		    const el = sectionRefs.current[firstIncomplete.shipping_type];
		    if (el) {
		      	const y = el.getBoundingClientRect().bottom + window.scrollY - window.innerHeight + 0;
		      	window.scrollTo({ top: y, behavior: 'smooth' });
		    }
	  	}
	};

	const showModalAddresses = () => {
		dispatch(handleChangeDataModalAddresses('isOpen', true));
		setTimeout(() => dispatch(handleChangeDataModalAddresses('isActive', true)), 0);
	};


	const closeBottomSheetDayTime = (contentIndex) => {
		let newContents = [...contents];
		newContents.map((content, index) => {
			if(index === contentIndex)
				content.showSheetDayTime = false;
		});
		dispatch(handleChangeDataPageCheckoutShipping('contents', newContents));
	};

	const toggleShosSheetDayTime = (contentIndex) => {
		let newContents = [...contents];
		newContents.map((content, index) => {
			if(index === contentIndex)
				content.showSheetDayTime = !content.showSheetDayTime;
		});
		dispatch(handleChangeDataPageCheckoutShipping('contents', newContents));
	};



 	const [isOpen, setOpen] = useState(false);

 	const deliveryDays = [
 		{id: '', title: 'سه‌شنبه', dayNum: '۱۹', price: '۹۹,۰۰۰', oldPrice: '۱۹۹,۰۰۰', selected: true},
 		{id: '', title: 'چهار‌شنبه', dayNum: '۲۰', price: '۹۹,۰۰۰', oldPrice: '۱۹۹,۰۰۰', selected: false},
 		{id: '', title: 'پنج‌شنبه', dayNum: '۲۱', price: '۹۹,۰۰۰', oldPrice: '۱۹۹,۰۰۰', selected: false},
 		{id: '', title: 'جمعه', dayNum: '۲۲', price: '۹۹,۰۰۰', oldPrice: '۱۹۹,۰۰۰', selected: false},
 		{id: '', title: 'شنبه', dayNum: '۲۳', price: '۹۹,۰۰۰', oldPrice: '۱۹۹,۰۰۰', selected: false},
 		{id: '', title: 'یکشنبه', dayNum: '۲۴', price: '۹۹,۰۰۰', oldPrice: '۱۹۹,۰۰۰', selected: false},
 		{id: '', title: 'دو‌شنبه', dayNum: '۲۵', price: '۹۹,۰۰۰', oldPrice: '۱۹۹,۰۰۰', selected: false},
 		{id: '', title: 'سه‌شنبه', dayNum: '۲۶', price: '۹۹,۰۰۰', oldPrice: '۱۹۹,۰۰۰', selected: false},
 		{id: '', title: 'چهار‌شنبه', dayNum: '۲۷', price: '۹۹,۰۰۰', oldPrice: '۱۹۹,۰۰۰', selected: false},
	]


	

    return (
    	<>

    	<div className="grow flex flex-col" style={{paddingTop: '0px', paddingBottom: '72px'}}>
			<div id="base_layout_desktop_static_header" className="w-full">
			</div>
			<div id="base_layout_desktop_sticky_header" className="sticky bg-neutral-000 z-3 w-full styles_BaseLayoutDesktop__stickyHeader__LYwWR">
			</div>
			<div className="grow bg-neutral-000 flex flex-col styles_BaseLayoutMobile__content__JgqoX">
				<div className="styles_PageLoader--hasPageContainer__gPBo1 hidden">
				</div>
				<div className="mb-5">
					<div className="lg:rounded-medium relative styles_Frame__Lu_I7 py-4 bg-neutral-000">
						<div className="relative flex flex-col lg:flex-row justify-center items-center mx-auto">
							<div>
								<div style={{height: '24px', lineHeight: '0'}}>
									<img className="w-full inline-block" src={DigiSvg} height="24" alt="digikala - کوچی" title="" style={{objectFit: 'contain'}} />
								</div>
							</div>
							<Link className="static mt-5 lg:mt-0 mr-5 lg:mr-0 ml-auto lg:absolute color-heading right-5 flex items-center text-black" to="" onClick={(e) => e.preventDefault()} >
								<div className="flex" onClick={() => navigate(-1)} >
									<ArrowForwardIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
								</div>
								<div className="text-h5 mr-5 lg:mr-1.5">آدرس و زمان ارسال
								</div>
							</Link>
						</div>
					</div>
					<div className="grid lg:grid-cols-4 grid-cols-1 lg:mt-3">
						<div className="lg:rounded-medium relative styles_Frame__Lu_I7 col-span-1 pb-3 lg:col-span-3 lg:pl-3">
							<div className="hidden">
							</div>
							<div className="lg:rounded-medium relative styles_Frame__Lu_I7 pr-5 pl-6 py-4">
								<div className="lg:rounded-medium bg-neutral-000">
									<div className="hidden">
									</div>
									<div className="flex flex-col lg:flex-col justify-between items-start lg:items-center">
										<div className="flex justify-between w-full flex-col">
											<div className="flex justify-start items-center w-full">
												<div onClick={showModalAddresses} className="flex items-center w-full border-complete-200 rounded px-4 py-2 cursor-pointer transition-all duration-450 !border-secondary-500">
													<div className="flex ml-3">
														<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#deliveryHeavy"></use>
														</svg>
													</div>
													<div className="w-full">
														<div className="flex justify-between w-full">
															<div className="text-body-1 text-neutral-900 transition-all duration-450 text-secondary-500">ارسال به آدرس انتخاب شده
															</div>
															<div className="mr-auto">
																<span className="inline-flex items-center cursor-pointer styles_Anchor--secondary__3KsgY text-body-2 self-end md:self-auto shrink-0 focus:outline-none" data-cro-id="shipping-change-address">
																	<span>تغییر آدرس
																	</span>
																	<div className="flex">
																		<ChevronLeftIcon sx={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}} />
																	</div>
																</span>
															</div>
														</div>
														<div className="text-body-1 text-neutral-800 transition-all duration-650 ease-in-out max-h-[1000px]">{activeAddress?.address}
														</div>
													</div>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>
							<div className="lg:border-complete-200 rounded-medium mt-3 mx-3 lg:mx-0 lg:px-6 lg:pt-6">
								
							{
								contents.map((content, contentKey) => {
									const selectedDay = content.available_days.find(day => day.isSelect === true);
									const timeSlots = selectedDay?.time_slots ?? [];
									const selectedTime = timeSlots?.find(time => time.isSelect === true);

									return (
										<div key={contentKey} ref={el => sectionRefs.current[content.shipping_type] = el} className="br-list-vertical-no-padding-200 py-3 lg:py-5 px-2 lg:px-0 mb-3 lg:mb-0 border-complete-200 !lg:border-none rounded-medium lg:rounded-0">
											<div>
												<div className="flex items-center px-4">
													<div className="ml-6">
														<div style={{width: '36px', height: '36px', lineHeight: '0'}}>
															<LazyLoadImage src={TrcuckPng} className="w-full inline-block" width={36} height={36} alt={content.shipping_type} style={{objectFit: 'contain'}} />
														</div>
													</div>
													<div className="grow flex flex-wrap justify-between items-start">
														<div>
															<div className="text-h5 text-neutral-800 flex flex-wrap">
																<span className="ml-2">{content.shipping_type}
																</span>
																<span className="bg-neutral-100 text-caption flex items-center justify-center px-2 rounded-medium-plus text-neutral-600">{toPersianDigits(content.items.length)} کالا
																</span>
															</div>
															<div className="text-caption text-neutral-600">{toPersianDigits(content.minDays)} روز
															</div>
														</div>
													</div>
												</div>
												<div className="mt-6 mb-7">
													<div className="overflow-x-hidden">
														<div className="flex flex-row justify-between w-full mx-auto relative">
															<div className="relative flex-1 w-full">
																<div>
																	<Swiper
																		className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-free-mode swiper-container-rtl" 
																		modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
											                            slidesPerView="auto"
											                            pagination={{clickable: true}}
											                            loop={false}
											                            navigation
											                            style={{ width: "100%" }}
											                            spaceBetween={0} >
											                            {
											                            	content.items.map((item, itemKey) => {
											                            		const productData = carts.find(cart => cart.sku === item.sku && cart.seller.id == item.seller);
											                            		if(productData) {
											                            			return (
												                            			<SwiperSlide style={{width: 'auto', height: 'auto'}} key={itemKey}>
															                            	<div className="px-4 border-complete-l-200">
																								<div className="styles_ProductImage__mKq1O">
																									<div className="relative mb-3">
																										<div layout="responsive" style={{width: '90px', height: '90px', lineHeight: '0'}}>
																											<LazyLoadImage src={IMAGE_ADDRESS + item.image} className="w-full inline-block" width={90} height={90} style={{objectFit: 'contain'}} alt={item.title} />
																										</div>
																										<div className="flex justify-center items-center absolute left-0 top-0 text-caption-strong">
																										</div>
																									</div>
																									<div className="flex items-center justify-between user-select-none px-2 rounded-medium border-complete-200 item-quantity_ItemQuantity__box__5r4FJ mt-3 mb-2">
																										<div onClick={() => handleAddToCartTwo(productData.seller, productData.selectedVariant, productData.product, productData.slug)} className="flex cursor-pointer p-0 lg:p-0">
																											<svg data-testid="quantity-increase" data-cro-id="cart-add-quantity" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
																												<use xlinkHref="#addSimple"></use>
																											</svg>
																										</div>
																										<span className="flex flex-col items-center justify-between text-primary-500">
																											<span className="relative flex items-center justify-center text-h5 item-quantity_ItemQuantity__boxCount__9ZT6i">{toPersianDigits(item.amount)}
																											</span>

																										</span>
																										<div className="flex cursor-pointer" onClick={() => handleMinusBtnTwo(productData.seller, productData.selectedVariant, productData.product, productData.slug)}>
																											<svg data-testid="quantity-decrease" data-cro-id="cart-delete-item-right" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
																												<use xlinkHref={`#${productData.number > 1 ? 'removeSimple' : 'delete'}`}></use>
																											</svg>
																										</div>
																									</div>
																									<div className="flex justify-start items-center">
																										{ productData.selectedVariant.optionTitle &&
																											<>
																											{ productData.selectedVariant.optionColor ?
																												<div className="rounded-circle border styles_ProductImage__colorCode___FL0K" style={{backgroundColor: `#${productData.selectedVariant.optionColor}`}}>
																												</div>
																											:
																												<div class="flex">
																													<svg style={{width: '14px', height: '14px', fill: 'var(--color-icon-high-emphasis)'}}>
																														<use xlinkHref="#variationSize"></use>
																													</svg>
																												</div>
																											}
																											<p className="text-caption text-neutral-600 mr-2 ellipsis">{productData.selectedVariant.optionTitle}
																											</p>
																											</>
																										}
																									</div>
																								</div>
																							</div>
															                            </SwiperSlide>
												                            		);
											                            		}
												                            		
											                            	})
											                            }
																	</Swiper>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="lg:border-none pb-2 lg:pb-0 border-complete-b">
													<div className="flex justify-between items-center mt-3">
														<div>
															<div className="flex items-center">
																<span className="text-body-2">زمان تحویل:
																</span>
																<span className="text-body2-strong mr-2">
																	<span className="text-neutral-800 text-body1-strong ml-1 inline-block">
																		{ selectedDay && selectedTime ?
																			`${selectedDay.weekday} ${selectedDay.dateShamsi} ساعت  ${toPersianDigits(formatTime(selectedTime.start))} تا ${toPersianDigits(formatTime(selectedTime.end))}`
																			:
																			'انتخاب نشده'
																		}
																	</span>
																</span>
															</div>
															<div className="flex items-center">
																<span className="text-body-2">هزینه ارسال:
																</span>
																<span className="text-body2-strong mr-2">{toPersianDigits(selectedDay.priceTxt)}
																</span>
																<div className="flex">
																	<svg style={{width: '14px', height: '14px', fill: 'var(--color-icon-high-emphasis)'}}>
																		<use xlinkHref="#toman"></use>
																	</svg>
																</div>
															</div>
															
														</div>
														<div className="shrink-0">
															<button onClick={() => toggleShosSheetDayTime(contentKey)} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--small__4O6Vv styles_btn--primary__y0GEv rounded-medium lg:hidden" data-cro-id="shipping-select-time">
																<div className="flex items-center justify-center relative grow">
																	{ !selectedDay || !selectedTime ?
																		'انتخاب زمان '
																		:
																		'تغییر زمان'
																	}
																</div>
															</button>
														</div>
													</div>
												</div>

											</div>

											{ content.showSheetDayTime && (
								                <div
								                    onClick={() => closeBottomSheetDayTime(contentKey)}
								                    style={{
								                        position: 'fixed',
								                        inset: 0,
								                        backgroundColor: 'rgba(0,0,0,0.5)',
								                        zIndex: 3,
								                    }}
								                />
								            ) }

											<Sheet style={{zIndex: "4"}} isOpen={content.showSheetDayTime} onClose={() => closeBottomSheetDayTime(contentKey)} detent="content-height" >
								                <Sheet.Container >
								                    <Sheet.Header className="">
								                    	
								                    	<div data-rsbs-header="true">
									                    	<div class="flex w-full justify-between items-center gap-3 mb-2 ">
																<div class="flex flex-col justify-center items-start">
																	<p class="text-h5 text-neutral-700">انتخاب بازه زمانی</p>
																	<p class="text-caption text-neutral-500">{content.shipping_type}</p>
																</div>
																<div class="flex cursor-pointer">
																	<svg onClick={() => closeBottomSheetDayTime(contentKey)} style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
																		<use xlinkHref="#close"></use>
																	</svg>
																</div>
															</div>
														</div>

								                    </Sheet.Header>
								                    <Sheet.Content>

								                        <div class="grow flex flex-col overflow-y-auto">
															<div class="grow flex flex-col styles_children__hHq5Q py-4 px-5">
																<section>
																	<div>
																		<div className="flex items-center">
																			<div className="hidden lg:flex items-center">
																				<div className="flex ml-4">
																					<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-black)'}}>
																						<use xlinkHref="#time"></use>
																					</svg>
																				</div>
																				<span className="text-neutral-800 text-body-1 flex flex-col">
																					<div className="flex">
																						<span className="text-body-2 ml-0.5">هزینه ارسال
																						</span>
																						<div className="flex items-center justify-center mx-1">
																							<div>
																								<div className="flex items-center justify-start">
																									<div className="flex justify-start items-center gap-1">
																										<span className="text-body2-strong">{toPersianDigits(selectedDay.priceTxt)}
																										</span>
																									</div>
																									<div className="flex items-center justify-between">
																										<div className="flex items-center">
																											<div className="flex">
																												<svg style={{width: '14px', height: '14px', fill: 'var(--color-icon-high-emphasis)'}}>
																													<use xlinkHref="#toman"></use>
																												</svg>
																											</div>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																					</div>
																					<div>
																						<span className="text-neutral-800 text-body1-strong ml-1 inline-block">
																						{ selectedDay && selectedTime ?
																							`${selectedDay.weekday} ${selectedDay.dateShamsi} ساعت  ${toPersianDigits(formatTime(selectedTime.start))} تا ${toPersianDigits(formatTime(selectedTime.end))}`
																							:
																							'زمان انتخاب نشده'
																						}
																						</span>
																					</div>
																				</span>
																			</div>
																		</div>
																	</div>
																	<div className="rounded-medium mt-3">
																		<div className="lg:border-complete-b-200">
																			<Swiper 
																				className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-free-mode swiper-container-rtl"
																				modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
														                        slidesPerView="auto"
														                        pagination={{clickable: true}}
														                        loop={false}
														                        navigation
														                        style={{ width: "100%" }}
														                        spaceBetween={0} >

														                        {
														                        	content.available_days.map((day, dayKey) => {
														                        		return (
														                        			<SwiperSlide key={`delivery-day-${dayKey}`} onClick={() => handleClickDay(contentKey, dayKey)} style={{width: 'auto', height: 'auto'}}>
														                        				<div className="pb-4 relative top-2 min-w-[80px] h-full">
																									<div  className={`relative py-2 px-1 min-w-[68px] lg:px-2 h-full items-center flex-col flex text-neutral-600 cursor-pointer border-complete rounded transition-colors lg:ml-2 ml-1.5 ${day.isSelect ? '!border-neutral-900' : ''}`}>
																										<span className={`text-body-1 ${day.selected ? 'text-neutral-900 text-body1-strong' : 'text-neutral-800'}`}>{day.weekday}
																										</span>
																										<span className={`text-3xl mt-0.5 ${day.selected ? 'font-bold text-neutral-900' : 'text-neutral-800'}`}>{day.day}
																										</span>
																										<div className="mt-auto">
																											<div className="rounded-sm mt-1 py-0.5" style={{backgroundColor: 'rgb(245, 245, 245)'}}>
																												<div className="px-1 text-center" style={{color: 'rgb(35, 37, 78)'}}>
																													<div className="flex flex-col items-center mx-1">
																														<div>
																															<div className="flex items-center justify-start">
																																<div className="flex justify-start items-center gap-1">
																																	<span className="text-dark-neutral-600 line-through">{day.oldPrice ?? ''}
																																	</span>
																																</div>
																																<div className="flex items-center justify-between">
																																	<div className="flex items-center">
																																		<div className="flex">
																																			<svg style={{width: '0px', height: '0px', fill: 'var(--color-icon-high-emphasis)'}}>
																																				<use xlinkHref="#toman"></use>
																																			</svg>
																																		</div>
																																	</div>
																																</div>
																															</div>
																														</div>
																														<div>
																															<div className="flex items-center justify-start">
																																<div className="flex justify-start items-center gap-1">
																																	<span className="text-body-2">{toPersianDigits(day.priceTxt)}
																																	</span>
																																</div>
																																<div className="flex items-center justify-between">
																																	<div className="flex items-center">
																																		<div className="flex">
																																			<svg style={{width: '14px', height: '14px', fill: 'rgb(35, 37, 78)'}}>
																																				<use xlinkHref="#toman"></use>
																																			</svg>
																																		</div>
																																	</div>
																																</div>
																															</div>
																														</div>
																													</div>
																												</div>
																											</div>
																										</div>
																									</div>
																								</div>
														                        			</SwiperSlide>
														                    			);
														                        	})
														                        }

																			</Swiper>
																		</div>
																		<div className="relative">
																			<div>
																				<Swiper
																					className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-rtl"
																					allowTouchMove={false}
																					navigation={false} 
																					pagination={false}
																					simulateTouch={false}
																					mousewheel={{ enabled: false }}
																					draggable={false} >
																					{
																						timeSlots.map((time, timeKey) => {
																							return (
																								<SwiperSlide key={`delivery-time-${timeKey}`}>
																									<div className="border-complete-b ml-2">
																										<div className="flex items-center cursor-pointer " onClick={() => handleClickTime(contentKey, timeKey)}>
																											<div className="px-4">
																												<label className="flex items-start py-3">
																													<input type="radio" name="83d057_2_5" className="hidden" value="" />
																													<span className="w-6 h-6 shrink-0" >
																													{ time.isSelect ?
																														<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																															<path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2Z" fill="var(--color-secondary-500)"></path>
																															<path d="M12 7C9.2 7 7 9.2 7 12C7 14.8 9.2 17 12 17C14.8 17 17 14.8 17 12C17 9.2 14.8 7 12 7Z" fill="white"></path>
																														</svg>
																														:
																														<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																															<path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM4 12C4 16.4 7.6 20 12 20C16.4 20 20 16.4 20 12C20 7.6 16.4 4 12 4C7.6 4 4 7.6 4 12Z" fill="#424750"></path>
																														</svg>
																													}
																													</span>
																												</label>
																											</div>
																											<div className="flex ml-4 justify-between items-center grow py-4">
																												<div className="grow flex items-center justify-between">
																													<span className="text-body-1 ml-4 lg:ml-0">ساعت {toPersianDigits(formatTime(time.start))} تا {toPersianDigits(formatTime(time.end))}
																													</span>
																												</div>
																											</div>
																										</div>
																									</div>
																								</SwiperSlide>
																							);
																						})
																					}
																				</Swiper>
																			</div>
																		</div>
																	</div>
																</section>
															</div>
														</div>

								                    </Sheet.Content>
								                </Sheet.Container>
								                <Sheet.Backdrop />
								            </Sheet>

										</div>
									);
								})
							}

							</div>
						</div>
						<aside className="col-span-1 lg:mt-0 relative z-1">
							<div className="sticky styles_CheckoutContainer__sideBar__WMKjM">
								<div className="lg:border-complete-200 lg:rounded-medium pt-2">
									<div className="px-5">
										<div className="flex items-center justify-between pt-3 relative flex-wrap">
											<div className="flex items-center">
												<div className="mr-1 text-body2-strong flex items-center text-neutral-600">
													<span>قیمت کالاها ({toPersianDigits(carts.length)})
													</span>
												</div>
											</div>
											<div className="flex items-center mr-auto">
												<div className="flex items-center flex-wrap justify-end">
													<div>
														<div className="flex items-center justify-start">
															<div className="flex justify-start items-center gap-1">
																<span className="!text-body-1 text-neutral-600 text-subtitle-strong">{toPersianDigits(Math.floor(totalProductPrice / 10).toLocaleString('fa'))}
																</span>
															</div>
															<div className="flex items-center justify-between">
																<div className="flex items-center">
																	<div className="flex">
																		<svg style={{width: '16px', height: '16px', fill: 'var(--color-neutral-600)'}}>
																			<use xlinkHref="#toman"></use>
																		</svg>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="border-complete-t-200 border-complete-b-200 mt-3 py-2">
										{
											Object.entries(shippingPrices).map(([type, {priceTxt, price}]) => {
												return (
													<div className="flex justify-between ai-cetner py-1 flex-wrap">
														<div className="flex items-center ml-4">
															<div className="ml-2" style={{width: '16px', height: '16px', lineHeight: '0'}}>
																<img className="w-full inline-block" src={TrcuckPng} width="16" height="16" alt="" title="" style={{objectFit: 'contain'}} />
															</div>
															<p className="text-body-2">{type}
															</p>
														</div>
														<div className="flex items-center text-caption text-neutral-800 mr-auto">
															<p className="flex items-center text-caption text-neutral-800">
																{ !price ?
																<div className="flex items-center">
																	<span className="">تعیین نشده
																	</span>
																</div>
																:
																<div>
																	<div className="flex items-center justify-start">
																		<div className="flex justify-start items-center gap-1">
																			<span className="text-body-1 ml-0.5">{toPersianDigits(priceTxt)}
																			</span>
																		</div>
																		<div className="flex items-center justify-between">
																			<div className="flex items-center">
																				<div className="flex">
																					<svg style={{width: '14px', height: '14px', fill: 'var(--color-icon-high-emphasis)'}}>
																						<use xlinkHref="#toman"></use>
																					</svg>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																}
															</p>
														</div>
													</div>
												);
											})
										}
										</div>
										{ profit > 0 &&
										<div className="flex items-center justify-between pt-3 relative flex-wrap">
											<div className="flex items-center">
												<div className="mr-1 text-body2-strong flex items-center text-neutral-600">
													<span className="text-hint-text-success text-body-1">سود شما از خرید</span>
												</div>
											</div>
											<div className="flex items-center mr-auto">
												<span className="ml-1 !text-body-1 text-neutral-600 text-subtitle-strong !text-hint-text-success">({toPersianDigits(profitPercent)}٪)</span>
												<div className="flex items-center flex-wrap justify-end">
													<div>
														<div className="flex items-center justify-start">
															<div className="flex justify-start items-center gap-1">
																<span className="!text-body-1 text-neutral-600 text-subtitle-strong !text-hint-text-success">{toPersianDigits((profit / 10).toLocaleString('fa'))}</span>
															</div>
															<div className="flex items-center justify-between">
																<div className="flex items-center">
																	<div className="flex">
																		<svg style={{width: '16px', height: '16px', fill: 'rgb(46, 123, 50)'}}>
																			<use xlinkHref="#toman"></use>
																		</svg>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										}
										{ isAllShippingTypesSelected &&
											<div className="flex items-center justify-between pt-3 relative flex-wrap">
												<div className="flex items-center">
													<div className="mr-1 text-body2-strong flex items-center text-neutral-600">
														<span className="text-body-1 text-neutral-850">مبلغ قابل پرداخت
														</span>
													</div>
												</div>
												<div className="flex items-center mr-auto">
													<div className="flex items-center flex-wrap justify-end">
														{ profit > 0 &&
														<span className="line-through ml-1 text-neutral-400 text-body1-strong">
															<div>
																<div className="flex items-center justify-start">
																	<div className="flex justify-start items-center gap-1">
																		<span className="text-body-2">{toPersianDigits(((totalShippingPrice + totalProductPrice) / 10).toLocaleString('fa'))}
																		</span>
																	</div>
																	<div className="flex items-center justify-between">
																		<div className="flex items-center">
																			<div className="flex">
																				<svg style={{width: '0px', height: '0px', fill: 'var(--color-icon-high-emphasis)'}}>
																					<use xlinkHref="#toman"></use>
																				</svg>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</span>
														}
														<div>
															<div className="flex items-center justify-start">
																<div className="flex justify-start items-center gap-1">
																	<span className="!text-body-1 text-neutral-600 text-subtitle-strong !text-neutral-850">{toPersianDigits(((totalShippingPrice + totalPrice) / 10).toLocaleString('fa'))}
																	</span>
																</div>
																<div className="flex items-center justify-between">
																	<div className="flex items-center">
																		<div className="flex">
																			<svg style={{width: '16px', height: '16px', fill: 'var(--color-neutral-600)'}}>
																				<use xlinkHref="#toman"></use>
																			</svg>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										}
										<div className="hidden lg:block mt-1 lg:my-4">
											<button onClick={handleClickPayBtn} className={`relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai ${!isAllShippingTypesSelected ? 'styles_btn--outlined__saFC3' : ''} styles_btn--primary__y0GEv rounded-medium w-full`} data-cro-id="shipping-choose-timeslot">
												<div className="flex items-center justify-center relative grow">
													{ isAllShippingTypesSelected ?
														'ثبت سفارش'
														:
														'انتخاب زمان ارسال'
													}
												</div>
											</button>
										</div>
									</div>
								</div>
							</div>
						</aside>
					</div>
				</div>
				<div className="z-2 flex flex-col hide-scrollbar styles_Layout__jJdiO hidden">
					<div className="grow bg-neutral-000 lg:rounded-large flex flex-col overflow-hidden styles_Layout__content__nlhKE"><header className="w-full bg-primary-500 text-white px-5 py-2">
						<div className="flex items-center justify-between">
							<h2 className="text-h4">پشتیبانی آنلاین</h2>
							<div className="flex cursor-pointer">
								<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
									<use xlinkHref="#arrowLeft"></use>
								</svg>
							</div>
						</div></header>
						<div className="">
						</div>
					</div>
				</div>
				<div className="relative">
					<button className="flex items-center justify-between text-button-1 styles_FabButton__5YQgj styles_FabButton--medium__5dCWs styles_FabButton--primary__fBOaQ p-3 fixed inline-block z-1 bottom-8 styles_Layout__CTAButton__WsxR_">
						<div className="flex items-center justify-center">
							<div className="flex styles_FabButton__icon__Nx9Sr">
								<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
									<use xlinkHref="#support"></use>
								</svg>
							</div>
						</div>
					</button>
				</div>
			</div>
		</div>



		<div className="w-full bg-neutral-000 z-3 fixed left-0 bottom-0 shadow-1-top" id="base_layout_mobile_footer" width="366" height="72">
			<div>
				<div className="px-4 py-3 bg-neutral-000 w-full">
					<div className="flex flex-row justify-between items-start">
						<div className="hidden lg:block">
							<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--outlined__saFC3 styles_btn--primary__y0GEv rounded-medium">
								<div className="flex items-center justify-center relative grow">بازگشت
								</div>
							</button>
						</div>
						<div className="w-full lg:w-unset">
							<div className="flex flex-row justify-between items-center">
								<div className="w-6/12 lg:w-unset styles_fixedCTA__ButtonBox__XKO9J">
									<button onClick={handleClickPayBtn} className={`relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai ${!isAllShippingTypesSelected ? 'styles_btn--outlined__saFC3' : ''} styles_btn--primary__y0GEv rounded-medium w-full`} data-cro-id="shipping-choose-timeslot">
										<div className="flex items-center justify-center relative grow">
											{ isAllShippingTypesSelected ?
												'ثبت سفارش'
												:
												'انتخاب زمان ارسال'
											}
										</div>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<Sheet style={{zIndex: "1"}} isOpen={isOpen} onClose={() => setOpen(false)} detent="content-height" >

		</Sheet>
		</>
    );
}

export default ShippingMobile;